import React, { Component } from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

import IconTicketEscalation from '../../assets/icons/IconTicketEscalation';

class TicketEscalationList extends Component {
    render() {
        return (
            <>
                {/* Dashboard Ticket Escalation */}
                <div className="bg-white rounded-md shadow-lg relative col-span-2 row-span-2">
                    <div className="text-nexcareblue1 p-7">
                        <div className="text-xl font-bold flex items-center pb-5">
                            {
                                this.props.loading
                                    ? <Skeleton height={40} width={40} />
                                    : <IconTicketEscalation />
                            }
                            {
                                this.props.loading
                                    ? <Skeleton height={20} width={120} className="ml-2" />
                                    : <p className="pl-3">Eskalasi</p>
                            }
                        </div>
                        {
                            this.props.loading
                                ? <Skeleton height={20} count={4} className="mb-1" />
                                : <div>
                                    {
                                        this.props.data.length > 0
                                            ? <div className="font-medium text-lg h-40 pr-1 overflow-auto">
                                                {
                                                    this.props.data.map((data, idx) =>
                                                        <div className="flex justify-between" key={idx}>
                                                            <p>{data.alias_name}</p>
                                                            <p>{data.total_ticket}</p>
                                                        </div>
                                                    )
                                                }
                                            </div>
                                            : <div className="font-medium text-lg h-40 overflow-auto flex justify-center items-center">
                                                <p className="text-darkgrey">Tidak ada data</p>
                                            </div>
                                    }
                                </div>
                        }
                    </div>
                </div>
            </>
        );
    }
}

export default TicketEscalationList;